import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

import { getRoutesProp } from 'utils/routing';

import shopControlsVisibilities from 'apps/header/utils/shopControlsVisibilities';

import AppBanner from 'apps/appBanner/containers/AppBanner';
import BasketSummary from 'apps/header/containers/BasketSummary';
import HeaderButtons from 'apps/header/components/HeaderButtons';
import HeaderSearch from 'apps/header/containers/HeaderSearch';
import InstantShopAd from 'apps/header/containers/InstantShopAd';
import JavascriptDisabledAlert from 'apps/browserWarnings/containers/JavascriptDisabledAlert';
import MiniTrolley from 'apps/header/containers/MiniTrolley';
import NavigationMenu from 'apps/topNavigation/containers/NavigationMenu';
import OfflineAlert from 'apps/browserWarnings/containers/OfflineAlert';
import PostcodeBanner from 'apps/header/containers/PostcodeBanner';
import PrimaryBar from 'apps/header/containers/PrimaryBar';
import ShopControl from 'apps/header/containers/ShopControl';
import SkipLinks from 'apps/header/components/SkipLinks';
import TopTabs from 'apps/header/containers/TopTabs';
import TrolleyMenu from 'apps/trolleyMenu/containers/TrolleyMenu';
import UnsupportedBrowserAlert from 'apps/browserWarnings/containers/UnsupportedBrowserAlert';

export default class Header extends PureComponent {
  static propTypes = {
    closeMobileNav: PropTypes.func.isRequired,
    isDesktopBreakpoint: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    location: PropTypes.object,
    logo: PropTypes.object,
    mobileNavOpened: PropTypes.bool,
    openMobileNav: PropTypes.func.isRequired,
    reportTopTabClicked: PropTypes.func,
    routes: PropTypes.array,
  };

  toggleMobileMenu = (event) => {
    if (this.props.isDesktopBreakpoint) {
      return;
    }

    event.preventDefault();
    if (this.props.mobileNavOpened) {
      this.props.closeMobileNav();
    } else {
      this.props.openMobileNav(this.props.location.pathname);
    }
  };

  render() {
    const { mobileNavOpened, isLoggedIn, location, logo, routes } = this.props;

    const shopControlsVisibility = getRoutesProp(routes, 'shopControlsVisibility', shopControlsVisibilities.NONE);
    const basketVisible = getRoutesProp(routes, 'basketVisible');

    return (
      <Fragment>
        <header className="hd-header stickToTop rs-stickyHeader">
          <SkipLinks />
          <JavascriptDisabledAlert />
          <UnsupportedBrowserAlert />
          <OfflineAlert />
          <AppBanner location={location} />
          <div className="hd-header__tabsAndHeader">
            <div className="hd-header__tabs">
              <TopTabs
                reportTopTabClicked={this.props.reportTopTabClicked}
              />
              <ShopControl shopControlsVisibility={shopControlsVisibility} />
            </div>
            <div className={classNames(
              'mainMenu hide-for-xlarge',
              'hd-header__mainMenu--prominent',
            )}
            >
              <button
                onClick={this.toggleMobileMenu}
                aria-label="Menu"
                aria-owns="navigation-menu"
                aria-haspopup={mobileNavOpened}
                className="hd-header__mainMenuBtn--prominent"
              />
            </div>
            <div className="hd-header__header">
              <div className={classNames(
                'hd-header__logo',
                'hd-header__logo--prominent',
              )}
              >
                <Link
                  to={logo.url}
                  title="Home"
                >
                  <img
                    src={logo.image}
                    alt={logo.altText}
                    className="hd-header__logoImg"
                  />
                </Link>
              </div>
              <div className="hd-header__content">
                <div className="hd-header__topBar">
                  <HeaderSearch />
                  <HeaderButtons isLoggedIn={isLoggedIn} location={location} />
                  <div className="hd-trolley">
                    <InstantShopAd />
                    {basketVisible && <MiniTrolley />}
                    <BasketSummary />
                  </div>
                </div>
                <PrimaryBar />
              </div>
            </div>
          </div>
        </header>
        <NavigationMenu location={location} />
        <TrolleyMenu shopControlsVisibility={shopControlsVisibility} />
        <PostcodeBanner />
      </Fragment>
    );
  }
}
